import { environment } from './../environments/environment';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { EmployeeValidationData, EPResponse, Family } from './models/model';
import { ApiServiceService } from './api-service.service';
import { AfterViewInit, Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { interval } from "rxjs";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'employee-ambassador';
  slides = [
    { image: './assets/ep_1.png', text: 'First' },
    { image: '/assets/ep_2.png', text: 'Second' }
  ];
  noWrapSlides = false;
  showIndicator = false;
  highlightedTab = 'AP';
  step = 1;
  selectedTabIndex = 1;
  response: EPResponse;
  errorMessage: string;
  employeeValidationData: EmployeeValidationData = new EmployeeValidationData(null, null, null);
  @ViewChild('headerBlock') headerBlock: ElementRef;
  @ViewChild('mainArea') mainArea: ElementRef;
  @ViewChild('offerCode') offerCode: ElementRef;

  invalidEmployeeId = false;
  invalidEmployeeIdTxt = "";
  invalidEmailId = false;
  invalidEmailIdTxt = "";
  invalidMobileNo = false;
  invalidMobileNoTxt = "";
  screenwidth = "desktop";
  resendOTP = true;
  otpCounter = 120;
  intervalRef: any;
  headerHeigth : number;
  otpVariable: string = '';
  tabImage : boolean = false;

  constructor(
    private santizer: DomSanitizer,
    private apiService: ApiServiceService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private renderer : Renderer2) { }

  ngOnInit() {
    this.screenwidth = window.innerWidth < 1070 ? 'mobile' : 'desktop';
  setTimeout(()=>{
    this.applyBackgroundStyle();
  }, 500)
  }
  

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.screenwidth = window.innerWidth < 1070 ? 'mobile' : 'desktop';
    this.applyHeaderBackgroundStyle();
    this.applyBackgroundStyle();
  }
  getHeader() {

    if (this.headerBlock !== undefined) {
      const headerBlock = this.headerBlock.nativeElement;
      this.headerHeigth = (headerBlock.clientWidth * (this.screenwidth === 'desktop' ? 554 : 580)) / 1366;
      const style = `min-height:` + this.headerHeigth + `px;`;
      return this.santizer.bypassSecurityTrustStyle(style);
    }
    return null;

  }

  getHeaderStyle(){
    if (this.headerBlock !== undefined) {
      const headerBlock = this.headerBlock.nativeElement;
      this.headerHeigth = (headerBlock.clientWidth * (this.screenwidth === 'desktop' ? 554 : 580)) / 1366;
      return { 'min-height': + this.headerHeigth + 'px;'};
    }
    return null;
  }


  // getBackground() {
  //   if (this.mainArea !== undefined && this.headerBlock !== undefined && this.screenwidth !== 'mobile') {
  //     //console.log(this.mainArea.nativeElement);
  //     const h = this.mainArea.nativeElement.clientHeight;
  //     const w = this.mainArea.nativeElement.clientWidth;
  //     let nh = Math.round(((653 / 688) * (h - this.headerBlock.nativeElement.clientHeight)));
  //     if (nh > (w/2 - 200)) {
  //       nh = w/2 - 200;
  //     }
  //     let stepNo = this.step;
  //     if (stepNo === 1000) {
  //       stepNo = 3;
  //     }
  //     if (this.highlightedTab === 'AP' && this.step > 3) {
  //       stepNo = 3;
  //     }

  //     const style = `
  //                 background-image: url('./assets/` + this.highlightedTab.toLowerCase() + `_` + (stepNo) + `.png'); 
  //                 background-repeat:no-repeat;
  //                 background-size:` + nh + `px;
  //                 background-position-y:` + this.headerHeigth + `px;
  //                 padding: 0;`;

  //     return this.santizer.bypassSecurityTrustStyle(style);
  //   }

  //   if (this.mainArea !== undefined && this.headerBlock !== undefined && this.screenwidth === 'mobile') {
  //     //console.log(this.mainArea.nativeElement);
  //     const h = this.mainArea.nativeElement.clientHeight;
  //     const w = this.mainArea.nativeElement.clientWidth;
  //     const nh = Math.round(((653 / 688) * (h - this.headerBlock.nativeElement.clientHeight)));
  //     let stepNo = this.step;
  //     if (stepNo === 1000) {
  //       stepNo = 3;
  //     }
  //     if (this.highlightedTab === 'AP' && this.step > 3) {
  //       stepNo = 3;
  //     }

  //     const style = `
  //     background-image: url('./assets/` + this.highlightedTab.toLowerCase() + `_` + (stepNo) + `_m.png'); 
  //     background-repeat:no-repeat;
  //     background-size:contain;
  //     background-position-y:bottom;
  //     padding: 0;`;
  //     return this.santizer.bypassSecurityTrustStyle(style);
  //   }

  //   return null;
  // }


  applyBackgroundStyle() {
    const backgroundStyle = this.getBackgroundStyle();
    Object.keys(backgroundStyle).forEach(style => {
      this.renderer.setStyle(this.mainArea.nativeElement, style, backgroundStyle[style]);
    });
  }

  applyHeaderBackgroundStyle() {
  const backgroundStyle = this.getHeaderStyle();
  Object.keys(backgroundStyle).forEach(style => {
    this.renderer.setStyle(this.headerBlock.nativeElement, style, backgroundStyle[style]);
  });
}

  getBackgroundStyle() {
    if (this.mainArea !== undefined && this.headerBlock !== undefined && this.screenwidth !== 'mobile') {
      this.tabImage = false;
  
      const h = this.mainArea.nativeElement.clientHeight;
      const w = this.mainArea.nativeElement.clientWidth;
      let nh = Math.round(((653 / 688) * (h - this.headerBlock.nativeElement.clientHeight)));

      if (nh > (w / 2 - 200)) {
        nh = w / 2 - 200;
      }
      let stepNo = this.step;
      if (stepNo === 1000) {
        stepNo = 3;
      }
      if (this.highlightedTab === 'AP' && this.step > 3) {
        stepNo = 3;
      }

      return {
        'background-image': `url(assets/${this.highlightedTab.toLowerCase()}_${stepNo}.png)`,
        'background-repeat': 'no-repeat',
        'background-size': `${nh}px`,
        'background-position-y': `${this.headerHeigth}px`,
        'padding': '0'
      };
    }

    if (this.mainArea !== undefined && this.headerBlock !== undefined && this.screenwidth === 'mobile') {
      if(window.innerWidth > 767 && window.innerWidth < 1070){
           this.tabImage = true;
          return { 'background-image'  : 'none'};
      }
      this.tabImage = false;
      //console.log(this.mainArea.nativeElement);
      const h = this.mainArea.nativeElement.clientHeight;
      const w = this.mainArea.nativeElement.clientWidth;
      const nh = Math.round(((653 / 688) * (h - this.headerBlock.nativeElement.clientHeight)));
      let stepNo = this.step;
      if (stepNo === 1000) {
        stepNo = 3;
      }
      if (this.highlightedTab === 'AP' && this.step > 3) {
        stepNo = 3;
      }

      return {
        'background-image': `url(assets/${this.highlightedTab.toLowerCase()}_${(stepNo)}_m.png)`,
        'background-repeat': 'no-repeat',
        'background-size': 'contain',
        'background-position-y': 'bottom',
        'padding': '0'
      }
    }
    return null;

  }

  changeTab(tab) {
    this.highlightedTab = tab;
    this.selectedTabIndex = tab === 'AP' ? 1 : 0;
    this.step = 1;
    this.employeeValidationData = new EmployeeValidationData(null, null, null);
    this.resendOTP = true;
    this.otpCounter = 120;
    this.invalidEmployeeId = false;
    this.invalidEmployeeIdTxt = "";
    this.invalidEmailId = false;
    this.invalidEmailIdTxt = "";
    this.invalidMobileNo = false;
    this.invalidMobileNoTxt = "";
  this.applyBackgroundStyle();
  }

  validateEmployee(program) {

    if (this.isValidEmployeeData()) {
      this.apiService.validateEmployee(this.employeeValidationData, program).then((result: EPResponse) => {
        console.log(result);
        if (result.status === 'SUCCESS') {
          this.response = result;
          this.step = 2;
          this.intervalRef = interval(1000).subscribe(t => {
            console.log(this.otpCounter);
            this.otpCounter--;
            if (this.otpCounter === 0) {
              this.resendOTP = false;
              this.intervalRef.unsubscribe();
            }
          });
        } else {
          if(result.desc.startsWith("We")){
            this.error = false;
          }else{
            this.error = true;
          }
        
          this.errorMessage = result.desc;
          this.step = 1000;
          //this.showError(result.desc);
        }
      });
    }
  }

  isValidEmployeeData(): boolean {
    let valid = true;
    if (this.employeeValidationData.emailId === null || this.employeeValidationData.emailId.trim().length === 0) {
      this.invalidEmailId = true;
      this.invalidEmailIdTxt = "Please enter a valid Email Id";
      valid = false;
    }
    if (this.employeeValidationData.employeeId === null || this.employeeValidationData.employeeId.trim().length === 0) {
      this.invalidEmployeeId = true;
      this.invalidEmployeeIdTxt = "Please enter a valid Employee Id";
      valid = false;
    }
    if (this.employeeValidationData.mobileNo === null || String(this.employeeValidationData.mobileNo).trim().length === 0) {
      this.invalidMobileNo = true;
      this.invalidMobileNoTxt = "Please enter a valid mobile number"
      valid = false;
    }
    return valid;
  }

  submitEP() {
    if (this.response  && this.response.code) {
      delete this.response.code; 
      this.response.otp= this.otpVariable;
    }

    this.apiService.registerEmployeeForEffoer(this.response).then((result: EPResponse) => {
      if (result.status === 'SUCCESS') {
        this.response = result;
        this.step = 3;
      } else {
        this.showError(result.desc, true);
      }
    });

  }

  updateOtpValue() {
    this.otpVariable = this.response.otp;
  }

  captureAPFamilyDetails() {
    let req: EPResponse = { ...this.response };

    delete (req as any).totalSlots; // removing to avaoid api call error

    this.apiService.validateEmployeeWithOPTForAPOffer(req).then((result: EPResponse) => {
      if (result.status === 'SUCCESS') {

        this.response = result;
        this.step = 3;
        if (!this.response.familyDetails || this.response.familyDetails.length === 0) {
          this.response.familyDetails = [];
        }

        let initialFamily: Family = new Family();
        if(this.response.familyDetails && this.response.familyDetails.length < this.response.totalSlots)
          this.response.familyDetails.push(initialFamily);

      } else {
        this.showError(result.desc, true);
      }
    });
  }

  addMoreRows() {
    if (!this.response.familyDetails) {
      this.response.familyDetails = [];
    }

    let initialFamily: Family = new Family();
     if(this.response.familyDetails && this.response.familyDetails.length < this.response.totalSlots)
      this.response.familyDetails.push(initialFamily);
  }

  validateFamilyDetails() {
    if(this.response.slotsAvailable === 0)
      return true;
    if (this.response.familyDetails) {
      for (let f of this.response.familyDetails) {
        if (!f.name || !f.mobileNo) {
          return true;
        }
      }
    } else if (!this.response.familyDetails) {
      return true;
    }
    return false;
  }

  deleteRow(index) {
    this.response.familyDetails.splice(index, 1);
  }

  error=true
  submitAP() {
    let req: EPResponse = { ...this.response };

    delete (req as any).totalSlots; 

    this.response.slotsAvailable = this.response.totalSlots - this.response.familyDetails.length;
    this.apiService.registerAP(req).then((result: EPResponse) => {
      if (result.status === 'SUCCESS') {

        this.response = result;
        this.step = 4;


      } else {
         
         
        if(result.desc.includes("We")){
          console.log(result,"if")
          this.error = false;
          this.errorMessage = result.desc;
          this.step = 1000;
        
        }else{
          console.log(result)
          this.error = false;
          this.errorMessage = result.desc;
          this.step = 1000;
        }
       
      }
    });

    //this.step = 4;
  }

  showError(msg, showError) {
    this.dialog.open(ErrorDialogComponent, {
      data: { message: msg, show: showError }
    })
  }

  copyCode() {

    navigator.clipboard.writeText(this.offerCode.nativeElement.textContent);
    this.snackBar.open("Offer code copied!", "Dismiss", {
      duration: 2000,
    });
  }


  startAgain() {
    this.step = 1;
    this.resendOTP = true;
    this.otpCounter = 120;
  }

  resentOTP(program) {
    this.apiService.resendOTP(this.employeeValidationData, program).then((result: EPResponse) => {
      if (result.status === 'SUCCESS') {
        this.showError(result.desc, false);
      } else {
        this.showError(result.desc, true);
      }
    });
  }
}